import { get, keyBy } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import MyCollectionTrackDiscussionTab from '../../../client/containers/MyCollection/MyCollectionTrackDiscussionTab';
import ReferenceGuidePDF from '../../../client/containers/ReferenceGuidePDF';
import {
    getCollection,
    getCollectionProfiles,
    getManyLearningAssets,
    getManyPeerRecommendations,
    getManyTeams,
    getManyUserCollections,
    getManyUserLearningAssets,
    hideModal,
    postUserCollection,
    showModal
} from '../../actions/index';
import FullPageLoadingIndicator from '../../components/FullPageLoadingIndicator';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import RoutingTabs from '../../components/RoutingTabs';
import { LEARNING_ASSET_TYPES, SEGMENT_EVENTS } from '../../Constants';
import { makeGetCollectionContent, makeGetObjectsFromStateByProperty } from '../../selectors/index';
import { isValidId } from '../../utils/StringUtils';
import CollectionBanner from './CollectionBanner';
import CollectionJourneySection from './CollectionJourneySection';
import CollectionLearningAssetRow from './CollectionLearningAssetRow';
import MobileCollectionJourneySection from './MobileCollectionJourneySection';
import MobileUserCollectionLearningAssetRow from '../MyCollection/MobileUserCollectionLearningAssetRow';
import MobileCollectionBanner from './MobileCollectionBanner';


class Collection extends Component {
    static propTypes = {
        collection: PropTypes.object,
        match: PropTypes.object.isRequired,
        learningAssets: PropTypes.arrayOf(PropTypes.object),
        history: PropTypes.object.isRequired,
        getCollection: PropTypes.func.isRequired,
        getManyLearningAssets: PropTypes.func.isRequired,
        postUserCollection: PropTypes.func.isRequired,
        userLearningAssetsByAssetId: PropTypes.object,
        getManyUserLearningAssets: PropTypes.func,
        getManyUserCollections: PropTypes.func,
        userLearningAssetLoading: PropTypes.bool,
        loggedInUser: PropTypes.object,
        loggedInUserCompany: PropTypes.object,
        collectionProfiles: PropTypes.array,
        isVerbAdmin: PropTypes.bool,
        location: PropTypes.object,
        getManyTeams: PropTypes.func,
        teamsById: PropTypes.object,
        isReviewCollection: PropTypes.bool,
        getManyPeerRecommendations: PropTypes.func,
        isAccountOwner: PropTypes.bool,
        referenceSectionItems: PropTypes.array,
        learningAssetsById: PropTypes.object,
        showModal: PropTypes.func,
        hideModal: PropTypes.func,
        setCollectionState: PropTypes.func,
        hasReferences: PropTypes.bool
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            creatingCollectionSubscription: false,
            recommender: '',
            latestRecommendation: {},
            screenWidth: window.innerWidth,
        };
    }

    componentDidMount() {
        const {
            match,
            getManyLearningAssets,
            getManyUserLearningAssets,
            userLearningAssetLoading,
            loggedInUser,
            getCollection,
            getManyTeams,
            isReviewCollection,
            history,
            location: { pathname = '', state = {} } = {}
        } = this.props;

        window.addEventListener('resize', this.updateScreenWidth);
        if (match.params.id) {
            return (
                getCollection({ collectionId: match.params.id, pathsContext: this.context.pathsWeb })
                    .then((collection) => {
                        const learningAssetIds = collection.contentIds.map((content) => content.id);
                        const promises = [
                            getManyLearningAssets({
                                _id: learningAssetIds,
                                getFullProjection: true,
                                pathsContext: this.context.pathsWeb
                            })
                        ];
                        if (isValidId(match.params.id)) {
                            const splitPathname = pathname.split('/');
                            splitPathname[2] = collection.permalink || match.params.id;
                            const updatedPathName = splitPathname.join('/');
                            history.replace({
                                pathname: updatedPathName,
                                state
                            });
                        }
                        if (!isReviewCollection) {
                            promises.push(this._getLatestRecommendation());
                            promises.push(getManyTeams({ pathsContext: this.context.pathsWeb }));
                            if (!userLearningAssetLoading && loggedInUser && loggedInUser._id) {
                                promises.push(
                                    getManyUserLearningAssets({
                                        userProfileId: loggedInUser._id,
                                        pathsContext: this.context.pathsWeb
                                    })
                                );
                            }
                        }
                        return Promise.all(promises);
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(([_, latestRecommendation]) => {
                        this.setState({
                            loading: false,
                            latestRecommendation
                        });
                    })
            );
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        const { getManyUserLearningAssets, loggedInUser, match, collection } = this.props;

        if ((!prevProps.loggedInUser || !prevProps.loggedInUser._id) && loggedInUser && loggedInUser._id) {
            return getManyUserLearningAssets({ userProfileId: loggedInUser._id, pathsContext: this.context.pathsWeb });
        }
        return null;
    }

    updateScreenWidth = () => {
        this.setState({screenWidth: window.innerWidth});
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScreenWidth);
      }

    createUserCollection = (values) => {
        const { collection, postUserCollection, loggedInUser, getManyUserCollections } = this.props;
        const newUserCollection = { ...values };
        newUserCollection.collectionId = collection._id;
        const params = {
            collectionId: collection._id,
            userProfileId: loggedInUser._id
        };

        return getManyUserCollections({ ...params, pathsContext: this.context.pathsWeb }).then((collections) => {
            if (!collections.length) {
                return postUserCollection({ body: newUserCollection, pathsContext: this.context.pathsWeb });
            }
            return collections[0];
        });
    };

    handleAssetRowClick = (learningAsset) => {
        const { history } = this.props;
        this.setState({ creatingCollectionSubscription: true });
        return this.createUserCollection().then((createdCollection) => {
            for (let i = 0; i <= createdCollection.content.length; i += 1) {
                if (createdCollection.content[i].learningAssetId === learningAsset._id) {
                    history.push(`/workspace/${createdCollection.content[i].userLearningAssetId}`, {
                        userCollection: {
                            id: createdCollection._id,
                            started: true
                        }
                    });
                    break;
                }
            }
        });
    };

    handleReviewAssetRowClick = (learningAsset) =>
        this.props.history.push(`/review/learningasset/${learningAsset._id}`);

    _displaySubscriptionBanner = () => {
        const {
            collection,
            history,
            collectionProfiles,
            isReviewCollection,
            referenceSectionItems,
            setCollectionState,
            learningAssets
        } = this.props;

        if (this.state.screenWidth <= 480) {
            return (
              <MobileCollectionBanner
                  collection={collection}
                  userCollection={collection}
                  className={'user-collections-widget'}
                  createUserCollection={this.createUserCollection}
                  memberProfiles={collectionProfiles}
                  collectionContent={learningAssets}
              />
            );
          }

        return (
            <CollectionBanner
                history={history}
                collection={collection}
                createUserCollection={this.createUserCollection}
                memberProfiles={collectionProfiles}
                hideCTAButton={isReviewCollection}
                referenceSectionItems={referenceSectionItems}
                setCollectionState={setCollectionState}
                collectionContent={learningAssets}
            />
        );
    };

    _getLatestRecommendation = () => {
        const { getManyPeerRecommendations, loggedInUser, teamsById, collection = {} } = this.props;
        return getManyPeerRecommendations({
            recommendedTo: loggedInUser._id,
            isRecommendedByTeamLead: true,
            parentId: collection._id,
            parentType: 'COLLECTION',
            pathsContext: this.context.pathsWeb
        }).then(({ collectionRecommendations = [] }) => {
            let latestRecommendation = collectionRecommendations[0] || {};
            if (latestRecommendation.teamId) {
                const team = teamsById[latestRecommendation.teamId] || {};
                for (let i = 0; i < (team.recommendedCollections || []).length; i += 1) {
                    const { collectionId, dueDate, assigned, message = '' } = team.recommendedCollections[i] || {};
                    if (collectionId === latestRecommendation.parentId) {
                        latestRecommendation = {
                            ...latestRecommendation,
                            note: message.length ? message : latestRecommendation.note,
                            dueDate,
                            assigned,
                            teamName: team.name
                        };
                        break;
                    }
                }
            }

            return latestRecommendation;
        });
    };

    _getCollectionLearningAssetRow = ({ collectionContentByAssetId, asset, isLockedReflection = false, hideDivider = false }) => {
        const { collection, userLearningAssetsByAssetId, isReviewCollection, history } = this.props;
        const assetIsLocked = collectionContentByAssetId[asset._id]?.isLocked
            ? collectionContentByAssetId[asset._id].isLocked
            : false;

        if (this.state.screenWidth <= 480) {
            return (
                <MobileUserCollectionLearningAssetRow
                    key={asset._id}
                    isLocked={assetIsLocked || isLockedReflection}
                    isLockedReflection={isLockedReflection}
                    goToUserLearningAsset={isReviewCollection ? this.handleReviewAssetRowClick : this.handleAssetRowClick}
                    userLearningAsset={asset}
                    userCollection={collection}
                    hideDivider={hideDivider}
                    isReflection={false}
                    status={'ASSIGNED'}
                />
            );
        }

        return (
            <CollectionLearningAssetRow
                key={asset._id}
                isReviewCollection={isReviewCollection}
                isLocked={assetIsLocked || isLockedReflection}
                isLockedReflection={isLockedReflection}
                history={history}
                handleAssetRowClick={isReviewCollection ? this.handleReviewAssetRowClick : this.handleAssetRowClick}
                collection={collection}
                userLearningAssetsByAssetId={userLearningAssetsByAssetId}
                learningAsset={asset}
            />
        );
    };

    _renderLearningJourneyTab = () => {
        const { collection, learningAssets } = this.props;
        const { latestRecommendation } = this.state;
        const collectionContentByAssetId = keyBy(get(collection, 'contentIds', []), 'id');
        const isPracticalApplication = learningAssets.some((asset) =>
            [LEARNING_ASSET_TYPES.PRACTICAL_APPLICATION, LEARNING_ASSET_TYPES.REFLECTION].includes(asset.type)
        );

        if (this.state.screenWidth <= 480) {
            return (
              <>
                  <div className={'learning-journey-tab asset-row-wrap'}>
                      {
                          <MobileCollectionJourneySection
                              {...this.props}
                              isPracticalApplication={isPracticalApplication}
                              rowRenderer={(asset, index, isLockedReflection, isReflection) =>
                                this._getCollectionLearningAssetRow({
                                    asset,
                                    collectionContentByAssetId,
                                    isLockedReflection,
                                    hideDivider: isReflection
                                })
                            }
                          />
                      }
                  </div>
              </>
          );
        }

        return (
            <>
                <div className={'learning-journey-tab'}>
                    <CollectionJourneySection
                        {...this.props}
                        isPracticalApplication={isPracticalApplication}
                        rowRenderer={(asset, index, isLockedReflection) =>
                            this._getCollectionLearningAssetRow({
                                asset,
                                collectionContentByAssetId,
                                isLockedReflection
                            })
                        }
                    />
                </div>
            </>
        );
    };

    _renderTrackDiscussionTab = () => {
        const {
            collection,
            loggedInUserCompany,
            loggedInUser,
            isVerbAdmin,
            isAccountOwner,
            learningAssetsById,
            hideModal,
            showModal,
            referenceSectionItems
        } = this.props;
        return (
            <MyCollectionTrackDiscussionTab
                learningAssetsById={learningAssetsById}
                loggedInUserCompany={loggedInUserCompany}
                loggedInUser={loggedInUser}
                isVerbAdmin={isVerbAdmin}
                isAccountOwner={isAccountOwner}
                isTeamAdmin={false}
                userCollection={collection}
                collection={collection}
                showModal={showModal}
                hideModal={hideModal}
                referenceSectionItems={referenceSectionItems}
            />
        );
    };

    getCollectionProfilesData = (params) => {
        const { collection } = this.props;
        const newParams = {
            collectionId: collection._id,
            ignoreDispatch: true,
            pathsContext: this.context.pathsWeb,
            ...params
        };
        return getCollectionProfiles(newParams);
    };

    _renderReferenceTab = () => {
        const { collection } = this.props;
        return <ReferenceGuidePDF collectionId={collection._id} />;
    };

    _makeAvailableRoutesForTabs = () => {
        const {
            collection,
            loggedInUserCompany,
            match,
            isReviewCollection,
            isVerbAdmin,
            hasReferences = false
        } = this.props;
        const tabList = [
            {
                tabName: 'Path',
                path: `/${isReviewCollection ? 'review' : ''}collection/${match.params.id}/path`,
                exact: true,
                render: this._renderLearningJourneyTab
            }
        ];

        if (hasReferences) {
            tabList.push({
                tabName: 'Summary',
                path: `/collection/${match.params.id}/summary`,
                exact: true,
                render: this._renderReferenceTab,
                onClick: () => {}
            });
        }

        tabList.push({
            tabName: 'Discussion Guide',
            path: `/collection/${match.params.id}/discussion`,
            exact: true,
            render: this._renderTrackDiscussionTab,
            onClick: () => {}
        });

        return tabList;
    };

    render() {
        const {
            collection,
            match: {
                params: { section }
            },
            isReviewCollection
        } = this.props;

        if (!section) {
            return (
                <Redirect
                    to={`/${isReviewCollection ? 'review' : ''}collection/${this.props.match.params.id}/path`}
                />
            );
        }

        const availableRoutes = this._makeAvailableRoutesForTabs();

        const routes = availableRoutes.map((routeItem) => (
            <Route key={routeItem.path} path={routeItem.path} exact={routeItem.exact} render={routeItem.render} />
        ));

        if (this.state.creatingCollectionSubscription || this.state.loading) {
            return <FullPageLoadingIndicator />;
        }

        return (
            <Page className={this.state.screenWidth <= 480 ? 'mobile-collection-banner' : 'collection-v2'}>
                {this._displaySubscriptionBanner()}
                <div className={'collection-page-tab-header'}>
                    <RoutingTabs routeTabs={availableRoutes} tabAlignment={'mx-auto'} />
                </div>

                <div className={'tab-container container'}>{routes}</div>
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const getCollectionContent = makeGetCollectionContent();
    const getUserLearningAssets = makeGetObjectsFromStateByProperty('userLearningAssets');

    return (state, ownProps) => {
        const {
            collections,
            profiles: { filteredById = [] },
            auth: { loggedInUser, loggedInUserCompanyId, isAccountOwner, isVerbAdmin },
            learningAssets,
            teams
        } = state;
        const {
            match: { params }
        } = ownProps;
        const collection = collections.byId[params.id] || collections.byPerma[params.id];
        const collectionContent = getCollectionContent(collection, state);
        const userLearningAssets = getUserLearningAssets(state, 'userProfileId', loggedInUser._id);
        const userLearningAssetsByAssetId = keyBy(userLearningAssets, 'trackId');
        const loggedInUserCompany =
            state.companies && state.companies.byId && state.companies.byId[loggedInUserCompanyId];
        const collectionProfiles = Object.values(filteredById);

        let referenceSectionItems = [];
        if (collectionContent.length) {
            referenceSectionItems = collectionContent
                .map((la) => la.sectionItems)
                .flat(1)
                .filter((si) => si && si.isIncludedInDiscussionGuide);
        }

        if (collection && collectionContent) {
            collection.content = collectionContent;
        }
        const hasReferences = !!referenceSectionItems.length;
        return {
            loggedInUser,
            loggedInUserCompany,
            isVerbAdmin,
            isAccountOwner,
            collection,
            learningAssets: collectionContent,
            userLearningAssetsByAssetId,
            collectionProfiles,
            userLearningAssetLoading: state.userLearningAssets.loading,
            teamsById: teams.byId,
            referenceSectionItems,
            learningAssetsById: learningAssets.byId,
            hasReferences
        };
    };
};

export const mapDispatchToProps = (dispatch) => ({
    getCollection: (params) => dispatch(getCollection(params)),
    getManyUserCollections: (params) => dispatch(getManyUserCollections(params)),
    getManyLearningAssets: (params) => dispatch(getManyLearningAssets(params)),
    postUserCollection: (params) => dispatch(postUserCollection(params)),
    getManyUserLearningAssets: (params) => dispatch(getManyUserLearningAssets(params)),
    getManyTeams: (params) => dispatch(getManyTeams(params)),
    getManyPeerRecommendations: (params) => dispatch(getManyPeerRecommendations(params)),
    showModal: (params) => dispatch(showModal(params)),
    hideModal: (params) => dispatch(hideModal(params))
});
export const CollectionComponent = Collection;
export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(Collection));
